export default __webpack_public_path__ + "static/267-09f1185b62da88bc66641a72ff856a4d.gif";